<template>
  <div id="dropDown-notif">
    <!-- NOTIFICATIONS -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="dataList.length" />

      <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
        <div class="notification-top text-center p-5 bg-primary text-white">
          <h3 class="text-white">{{ dataList.length }} Notifications</h3>
          <p class="opacity-75">App Notifications</p>
        </div>

        <VuePerfectScrollbar search :data="dataList" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
          <ul class="bordered-items">
            <li v-for="ntf in dataList" :key="ntf.id" @click="destinationPage(ntf.id, ntf.modeleNotification.title)" class="flex justify-between px-4 py-4 notification cursor-pointer">
              <div class="flex items-start">
                <feather-icon :icon="ntf.modeleNotification.icon" :svgClasses="['stroke-current mr-1 h-6 w-6']" :style="{ color: ntf.modeleNotification.color }"></feather-icon>
                <div class="mx-2">
                  <span class="font-medium block notification-title" :style="{ color: ntf.modeleNotification.color }">{{ ntf.modeleNotification.title }}</span>
                  <small>{{ ntf.modeleNotification.msg + "" + ntf.msg }}</small>
                </div>
              </div>
              <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdAt) }}</small>
            </li>
          </ul>
        </VuePerfectScrollbar>

        <div class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer">
          <span @click="toAllNotification()">Voir toutes les notifications</span>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import notificationService from "@/http/requests/notification/index.js";
import { data } from "@chenfengyuan/vue-countdown";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      currentPage: 1,
      baseUrl: "",
      active: false,
      dialog: false,
      popupActiAdd: false,
      showChart: false,
      colorx: this.$store.state.themePrimaryColor,
      popupActivo5: false,
      showdata: false,
      dataList: [],
      queriedItems: 0,
      shadowpdf: false,
      cellAutoWidth: true,
      headerTitle: ["id", "modeleNotification", "compte", "createdAt", "isRecovered", "isSeen"],
      headerVal: ["id", "modeleNotification", "compte", "createdAt", "isRecovered", "isSeen"],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  // watch: {
  //     dataList: function () {
  //         this.$vs.loading.close("#dropDown-notif > .con-vs-loading");
  //     }
  // },
  methods: {
    destinationPage(id, title) {
      switch (title) {
        case "Nouvel arrivage":
          notificationService.setNotificationSeen(id).then((any) => {
            this.loadData();
          });
          this.$router.push("/ArrivageClient");
          break;
        case "Nouvelle circulaire":
          notificationService.setNotificationSeen(id).then((any) => {
            this.loadData();
          });
          this.$router.push("/CirculaireClient");
          break;
        case "Nouvelle Création":
          notificationService.setNotificationSeen(id).then((any) => {
            this.loadData();
          });
          this.$router.push("/NouvelArticle");
          break;
        default:
          console.log(`Sorry, we are out of ${title}.`);
      }
    },
    toAllNotification() {
      this.$router.push("/AllNotifications");
    },
    loadData() {
      try {
        /* notificationService.getAllNotification().then(response => {
                    this.dataList = response.data;
                    console.log("***************");
                    console.log(response.data);
                }) */
        notificationService.findByCompte(localStorage.getItem("username", JSON.stringify())).then((response) => {
          this.dataList = JSON.parse(JSON.stringify(response.data));
        });
        // this.$vs.loading.close("#dropDown-notif > .con-vs-loading");
      } catch {
        // this.$vs.loading.close();
        // this.$vs.loading.close("#dropDown-notif > .con-vs-loading");
        this.$vs.loading.close();
        this.$vs.notify({
          time: 10000,
          title: "Erreur s'est produite l'ors de la récupération de données",
          text: "Erreur",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circles",
        });
      }
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return "Il y a " + years + (years > 1 ? " ans " : " année ");
      } else if (days > 0) {
        return "Il y a " + days + (days > 1 ? " Jours " : " Jour ");
      } else if (hours > 0) {
        return "Il y a " + hours + (hours > 1 ? " H " : " Heurs ");
      } else if (minutes > 0) {
        return "Il y a " + minutes + (minutes > 1 ? " Mins " : " Min ");
      } else if (seconds > 0) {
        return "Il y a " + seconds + (seconds > 1 ? " Sec" : "Maintenant");
      }

      return "Maintenant";
    },
    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      let date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date;
    },
  },
  created() {
    this.loadData();
  },
};
</script>
